import SKIP_WORDS from './nameArticles.json';

export const changeDateFormatToMMDDYY = (date) => {
    if (date) {
      const [year, month, day] = date.split('-');
      return (`${month}/${day}/${year}`);
    }
  };

/**
 * Name shown in the header's top-left corner: the FIRST NAME only of the person
 * whose projector is open — never the projector's display name, which belongs
 * to the "<Name>'s Projector" title on the right. Falls back to the email
 * handle for accounts with no name saved.
 */
export const getHeaderName = (details) => (
  details?.firstname?.trim() || details?.email?.split('@')[0] || ''
);

export const getDisplayName = (fullName) => {
  if (!fullName) return '';
  const words = fullName.trim().split(/\s+/);
  if (words.length > 1 && SKIP_WORDS.includes(words[0].toLowerCase())) return fullName.trim();
  return words[0];
};
